import type { IMultiColumnProps } from 'blocks/MultiColumns'
import type {
  ILabelsGroupDescription3Line,
  IMoviesDescriptions1Line,
} from 'blocks/MultiColumns/Templates'
import type { IDescriptionProps } from './Description'

import { INDENTS } from 'vars/index'

export const DescriptionDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type DescriptionDirection =
  (typeof DescriptionDirection)[keyof typeof DescriptionDirection]

export const DescriptionJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type DescriptionJustifyContent =
  (typeof DescriptionJustifyContent)[keyof typeof DescriptionJustifyContent]

export const DescriptionAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
} as const
export type DescriptionAlignItems =
  (typeof DescriptionAlignItems)[keyof typeof DescriptionAlignItems]

export const DescriptionColumnGap = {
  INDENT_0: INDENTS.INDENT_0,
  INDENT_20: INDENTS.INDENT_20,
  INDENT_40: INDENTS.INDENT_40,
  INDENT_60: INDENTS.INDENT_60,
  INDENT_80: INDENTS.INDENT_80,
} as const
export type DescriptionColumnGap =
  (typeof DescriptionColumnGap)[keyof typeof DescriptionColumnGap]

export const DescriptionRowGap = {
  INDENT_0: INDENTS.INDENT_0,
  INDENT_20: INDENTS.INDENT_20,
  INDENT_40: INDENTS.INDENT_40,
  INDENT_60: INDENTS.INDENT_60,
  INDENT_80: INDENTS.INDENT_80,
} as const
export type DescriptionRowGap =
  (typeof DescriptionRowGap)[keyof typeof DescriptionRowGap]

export type DescriptionType = Omit<
  ILabelsGroupDescription3Line &
    IMoviesDescriptions1Line &
    IMultiColumnProps &
    IDescriptionProps,
  'children' | 'rowGap'
>
